import baguetteBox from "baguettebox.js";
import "baguettebox.js/dist/baguetteBox.min.css!";

class Gallery {
  constructor() {
    this._init();
  }

  _init() {
    document.addEventListener("DOMContentLoaded", event => {
      baguetteBox.run(".gallery");

      const $ = jQuery;
      $(".item-photo__zoom").click(function() {
        $(this)
          .next()
          .get(0)
          .click();
      });

      /*<div class="gallery">
          <a href="img/2-1.jpg" data-caption="Image caption">
              <img src="img/thumbs/2-1.jpg" alt="First image">
          </a>
          <a href="img/2-2.jpg">
              <img src="img/thumbs/2-2.jpg" alt="Second image">
          </a>
          ...
      </div>*/
    });
  }
}

export const gallery = new Gallery();
